import { render, staticRenderFns } from "./template-activity-measurements.vue?vue&type=template&id=5c4fc168"
import script from "./template-activity-measurements.vue?vue&type=script&lang=js"
export * from "./template-activity-measurements.vue?vue&type=script&lang=js"
import style0 from "./template-activity-measurements.vue?vue&type=style&index=0&id=5c4fc168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports